<template>
  <section class="page container py-5">
    <h1 class="mb-3">Downloads</h1>
    <p class="mb-4">
      This is a placeholder page. You can replace this with your real downloads content.
    </p>
    <a
      class="btn btn-danger"
      href="https://gapmanagement.institute/downloads"
      target="_blank"
      rel="noopener"
    >
      Open Downloads on GAP website
    </a>
  </section>
</template>

<script>
export default {
  name: 'DownloadsPage'
}
</script>
